export default __webpack_public_path__ + "static/media/logo_farmax.f459dece.png";